import { Navigate, Outlet } from 'react-router-dom';
import { useIsClient } from '@/shared/hooks/useIsClient';
import { useIsTeamMember } from '@/shared/hooks/useIsTeamMember';
import { routes } from '@/shared/config/routes';

type WalletBlockedGuardProps = {
  redirectTo?: string;
};

/** Blocks CLIENT and team-member accounts from wallet routes. */
export function WalletBlockedGuard({
  redirectTo = routes.campaigns,
}: WalletBlockedGuardProps) {
  const isClient = useIsClient();
  const isTeamMember = useIsTeamMember();
  if (isClient || isTeamMember) return <Navigate to={redirectTo} replace />;
  return <Outlet />;
}
